import {
  axios, withCancellation, REQUEST_METHODS, withPartialContent
} from 'shared/services/axios'

export function fetchContentItems(organizationId, { page, activeFilters, sort }) {
  return withCancellation(
    REQUEST_METHODS.post,
    `/api/v1/organizations/${organizationId}/content_items`,
    {
      page,
      active_filters: activeFilters,
      sort
    })
    .then(response => response.data)
}

export function fetchContentItem(itemId) {
  return axios.get(`/api/v1/items/content_items/${itemId}`)
    .then(response => response.data)
}

export function createContentItem(params) {
  return axios.post('/api/v1/items/content_items', params)
    .then(response => response.data)
}

export function updateContentItem(item) {
  return axios.put(`/api/v1/items/content_items/${item.id}`, item)
    .then(response => response.data)
}

export function archiveContentItem(itemId, makeItemsOffline) {
  return axios.put(`/api/v1/items/content_items/${itemId}/archive`, {make_items_offline: makeItemsOffline})
    .then(response => response.data)
}

export const createSnapshotUrl = withPartialContent(
  ({ contentItemId, guid = null }) => {
    return axios.post(`/api/v1/content_items/${contentItemId}/snapshots`, {
      guid
    })
  }
)

export function analyzeUrl({ contentItemId }) {
  return axios.post(`/api/v1/content_items/${contentItemId}/analyses`)
}

export const getFileMetadata = withPartialContent(({ contentItemId }) => {
  return axios.get(`/api/v1/content_items/${contentItemId}/files`)
})

export function fetchContentItemBoards(contentItemId, params) {
  return axios.post(`/api/v1/content_items/${contentItemId}/boards`, params)
    .then(response => response.data)
}

export const fetchPreviewItem = (contentItemId) => {
  return axios.get(`/api/v1/content_items/${contentItemId}/preview`)
    .then(response => response.data)
}

export const fetchContentItemsWithSummaries = (organizationId, params) => {
  return axios.get(`/api/v1/organizations/${organizationId}/content_item_summaries`, { params })
    .then(response => response.data)
}

export const generateSummariesForContentItems = withPartialContent(
  ({ organizationId, contentItemIds, guid = null }) => {
    return axios.post(`/api/v1/organizations/${organizationId}/content_item_summaries`, {
      content_item_ids: contentItemIds,
      guid
    })
  })

export const generateSummaryForContentItem = withPartialContent(
  ({ organizationId, contentItemId, guid = null }) => {
    return axios.post(`/api/v1/organizations/${organizationId}/content_item_summaries/${contentItemId}/generate`, {
      guid
    })
  })

export const fetchContentItemSummary = (organizationId, contentItemId) => {
  return axios.get(`/api/v1/organizations/${organizationId}/content_item_summaries/${contentItemId}`)
    .then(response => response.data)
}

export const updateContentItemSummary = withPartialContent(
  ({ organizationId, contentItemId, summary, guid = null }) => {
    return axios.put(`/api/v1/organizations/${organizationId}/content_item_summaries/${contentItemId}`, {
      summary,
      guid
    })
  })

export const fetchDuplicates = (organizationId, options = {}) => {
  return axios.get('/api/v1/duplicates', {
    params: {
      organization_id: organizationId,
      ...options
    }
  })
    .then(response => response.data)
}
